export default function ModerationController() : JSX.Element {
    return <></>
}